import type { RouteSeo } from '@/shared/seo/types';
import type { ListingSeo } from '@/shared/features/seo/domain/models/Seo';

export const searchImageSeo: RouteSeo = {
  title: 'Image Search | BlueStone',
  robots: 'noindex,nofollow',
};

/** Client-side document head (PlpSeoHead) — mirrors `searchImageSeo` for SPA navigation. */
export const searchImageListingSeo: ListingSeo = {
  title: searchImageSeo.title,
  robotsMeta: 'noindex,nofollow',
};
